import React , {useContext} from 'react'
import { Route, Redirect } from 'react-router'
import { AuthContext } from '../context/auth'

function PrivateRoute({ component: Component, ...rest }) {
    const { user } = useContext(AuthContext);
    return (
        <Route {...rest} render={props => (
            user !== null ? (
                <>
                    <Component {...props} />
                </>
            ) : (
                <Redirect to={{
                    pathname: '/login',
                    state: { from: props.location }
                }} />
            )
        )} />
    );
}

export default PrivateRoute;
